import { MESSAGE_ID_PARAM } from "@/constants/messages";

export type SigneringSearchParams = {
  erklaeringId: string | null;
  erklaeringIndsendes: string | null;
  messageId: string | null;
  signeringstype: string | null;
  signingUser: string | null;
};

export const getSigneringSearchParams = (
  searchParams: URLSearchParams,
): SigneringSearchParams => ({
  messageId: searchParams.get("messageId"),
  erklaeringId: searchParams.get("erklaeringId"),
  erklaeringIndsendes: searchParams.get("erklaeringIndsendes"),
  signeringstype: searchParams.get("signeringstype"),
  signingUser: searchParams.get("signingUser"),
});

export const isPaabudIndberetningSignering = (
  signeringstype: string | null,
): boolean => signeringstype === "PaabudIndberetning";

export const isPaalaegIndberetningSignering = (
  signeringstype: string | null,
): boolean => signeringstype === "PaalaegIndberetning";

export const isAfgorelseIndberetningSignering = (
  signeringstype: string | null,
): boolean =>
  isPaabudIndberetningSignering(signeringstype) ||
  isPaalaegIndberetningSignering(signeringstype);

export const isEfteruddannelseIndberetningSubmitted = (
  erklaeringIndsendes: string | null,
) => erklaeringIndsendes?.toLowerCase() === "true";

export const getSigneringMessage = (messageId: string | null): string =>
  MESSAGE_ID_PARAM[
    Number.parseInt(messageId ?? "0", 10) as keyof typeof MESSAGE_ID_PARAM
  ] ?? "";
